export default "__VITE_ASSET__Ggn7Epoj__"